
const $priceDom = $('#sp_price1');
const $cPriceDom = $('#sp_price2');
const $offPriceDom = $('.sp-price-group .sp-p span');
const $numDom = $('#calcNumber');

const productData = window.product || [];

/** 获取当前选中的变量 */
function getCur() {
    const opts = {
        option1: $('#sp-opt-group1 div.active').attr('data-val'),
        option2: $('#sp-opt-group2 div.active').attr('data-val'),
        option3: $('#sp-opt-group3 div.active').attr('data-val')
    };

    return productData.find(item => {
        return (!opts.option1 || item.option1 == opts.option1) &&
            (!opts.option2 || item.option2 == opts.option2) &&
            (!opts.option3 || item.option3 == opts.option3);
    });
}

/** 更新价格显示 */
function changePrice() {
    const curVariant = getCur();
    if (!curVariant) return;

    const num = parseInt($numDom.val()) || 1;

    // 识别当前页面使用的小数点符号
    const currentText = $priceDom.text().trim();
    const decimalMatch = currentText.match(/([\.,])(\d+)(?!.*[\.,])/);

    const decimalSeparator = decimalMatch ? decimalMatch[1] : '.';
    const decimalLength = decimalMatch ? decimalMatch[2].length : 0;

    // 格式化输出
    const formatValue = (cents) => {
        let val = (cents * num / 100).toFixed(decimalLength);
        if (decimalSeparator === ',') {
            val = val.replace('.', ',');
        }
        return val;
    };

    const price = formatValue(curVariant.price);
    const compare = formatValue(curVariant.compare_at_price);

    // 计算折扣
    let offPercent = 0;
    if (curVariant.compare_at_price > curVariant.price) {
        offPercent = 100 - Math.ceil((curVariant.price / curVariant.compare_at_price) * 100);
    }

    const priceRegex = /\d+(?:[.,]\d+)*/;
    const offRegex = /(\d+)(?=(?:<[^>]+>|\s)*%)/g;

    const updateHTML = ($el, regex, value) => {
        if ($el && $el.length) {
            const text = $el[0].textContent.trim();
            const newHtml = text.replace(regex, value);
            if ($el.html() !== newHtml) {
                $el.html(newHtml);
            }
        }
    };

    updateHTML($priceDom, priceRegex, price);
    updateHTML($cPriceDom, priceRegex, compare);
    updateHTML($offPriceDom, offRegex, offPercent);
}

// 绑定选项点击事件
$(document).on('click', '.sp-option', function () {
    setTimeout(changePrice, 10);
});

$('.sp_buy_now').click(function () {

    let num = $numDom.val();
    let id = getCur().id;
    window.location.href = '/cart/' + id + ':' + num;

});

/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */

document.addEventListener('DOMContentLoaded', function () {
    // 倒计时
    function getRandomNum(min, max) {
        return Math.floor(Math.random() * (max - min)) + min
    }

    let endTimeG

    function cutDownTime() {
        let nowTime = new Date()
        let endTime = new Date(endTimeG)

        let leftTime = endTime.getTime() - nowTime.getTime()
        if (leftTime < 0) {
            setupNewCountdown()
            leftTime = 0
        }
        let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
            leftM = Math.floor((leftTime / (1000 * 60)) % 60),
            leftS = Math.floor((leftTime / 1000) % 60)
        leftH = leftH >= 10 ? leftH : '0' + leftH
        leftM = leftM >= 10 ? leftM : '0' + leftM
        leftS = leftS >= 10 ? leftS : '0' + leftS

        return {
            hour: leftH,
            minute: leftM,
            second: leftS,
        }
    }
    function setupNewCountdown() {
        const randomHour = getRandomNum(1, 9)
        const currentTime = new Date()
        endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
    }
    let intervalId

    function getCutDownTime() {
        setupNewCountdown()
        if (intervalId) clearInterval(intervalId)
        intervalId = setInterval(function () {
            let cutDownTimeText = cutDownTime()
            $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
            $('.sp_top_cut_down .sp_left_view .sp_minute').html(
                cutDownTimeText.minute
            )
            $('.sp_top_cut_down .sp_left_view .sp_second').html(
                cutDownTimeText.second
            )
        }, 1000)
    }

    getCutDownTime()
    var _index = 0
    var priceArr = productData.map(item => (item.price) / 100)
    var prices = 0
    $('.sp-option').click(function () {
        $(this).siblings().removeClass('active')
        $(this).addClass('active')
        // let colorOptions = $('.sp-opt-group1 .sp-option.active').index()
        let numOptions = $('.sp-opt-group3 .sp-option.active').index()
        let typeOptions = $('.sp-opt-group2 .sp-option.active').index()
        _index = numOptions+typeOptions*4
        let numX=0;
        // console.log(getCur(), '666')
        if (numOptions == 0) {
            numX=1;
        } else if (numOptions == 1) {
            numX=3;
        } else if(numOptions == 2){
            numX=5;
        }else{
            numX=10;
        }
        if(typeOptions==1){
            numX=numX+1;
            $('.sp-img-inner .sp-img-p').css('clip-path','')
        }else{
            $('.sp-img-inner .sp-img-p').css('clip-path','inset(10px)')
        }
        prices = (getCur().price / 100 / numX).toFixed(2)
        $('.option-name1 span').text(prices)
        $('.sp-img-inner .sp-img-p').attr('src',spImgList[_index])
        // $('.sp-img-inner .sp-img-p')
        //     .eq(_index)
        //     .addClass('active')
        //     .siblings()
        //     .removeClass('active')

        // if (typeOptions == 1) {
        //   $('.sp-img-adds').show()
        // } else {
        //   $('.sp-img-adds').hide()
        // }
    })

    let spImgList = [
    // 无绑品
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/40_abf10364-6507-4673-8c90-7ebe3515b7ed.png?v=1739867315',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/44_7b8a8f52-e5f3-4e93-beeb-2b376caf6f27.png?v=1775024657',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/49_b5f5103f-88d2-41e6-8b1d-bb733ebffa2e.png?v=1775024657',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/5_5UK.png?v=1775028853',

    // +快充器
    'https://cdn.shopify.com/s/files/1/0657/9303/2497/files/4_ffdab015-66bc-4a79-aaf5-826c734e6669.png?v=1775809580',
    'https://cdn.shopify.com/s/files/1/0657/9303/2497/files/3_c0845ae4-cbf8-4eda-a31f-2b7df51a74e9.png?v=1775809579',
    'https://cdn.shopify.com/s/files/1/0657/9303/2497/files/2_62c949aa-ab08-4beb-bbc8-8ffb30a0e6a4.png?v=1775809580',
    'https://cdn.shopify.com/s/files/1/0657/9303/2497/files/1_24132423-dc37-4373-a0b8-7783ec3a30f7.png?v=1775809579',
    // 买1
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/37_c1d3b116-1922-4b5e-8c90-4d1827af8e15.png?v=1775024657',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/39_48573e82-207f-4261-b59a-3ba7ec5604ce.png?v=1739867315',
    
    // 2+1
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/41_bb74faf8-a81e-4783-9bbe-7fe71b1b95e2.png?v=1739867315',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/43_20af6734-d4d8-43bc-812e-be7aa921deb2.png?v=1775024657',
    
    // 3+2
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/46_80a7d98a-8276-4517-a2e9-d7c4366bc31c.png?v=1775024657',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/48_b05e469b-b585-4022-a950-33c3340bb45d.png?v=1775024657',
    
    // 5+5
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/5_5US.png?v=1775028853',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/5_5EU.png?v=1775028853',

    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/20260316__img__US3.jpg?v=1773626173',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/20260316__img__EU3.jpg?v=1773626173',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/20260316__img__UK3.jpg?v=1773626173',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/20260316__img__US.jpg?v=1773626173',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/20260316__img__EU.jpg?v=1773626173',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/20260316__img__UK.jpg?v=1773626173',
    // 'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/lQLPJwp-ft_lFG3NAljNA9SwxESQTbrtxPkJgQBDaKovAQ_980_600.png?v=1772707026',
    //       'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/lQLPKGLAiD6hVG3NAljNA9SwegpTXkIOLwAJgQBDaKovAA_980_600.png?v=1772707026',
    // 'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/lQLPKHD2guPKvi3NAljNA9Sw846AsJn_OO8JgQFrWc5oAQ_980_600.png?v=1772707026',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/20260316__img__US5.jpg?v=1773626173',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/20260316__img__EU5.jpg?v=1773626173',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/20260316__img__UK5.jpg?v=1773626173',


    "https://cdn.shopify.com/s/files/1/0675/5234/6360/files/1_2.png?v=1770200226",
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/1_78472f7e-8cc4-4aa2-a060-f6e46a9b91d7.png?v=1770200226',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/1_21e8a7f3-0fec-4b3e-a116-b473c0f0a997.png?v=1770200226',
    "https://cdn.shopify.com/s/files/1/0675/5234/6360/files/2_1_2.png?v=1770200500",
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/2_1_6e1d7a1e-4385-49bb-adab-0174ccc1523b.png?v=1770200500',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/2_1.png?v=1770200500',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/3_2_2.png?v=1770200539',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/3_2.png?v=1770200539',
    'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/3_2_0e971b8d-c7f7-4fba-b37e-de155e5dbb71.png?v=1770200539'
]

    new Swiper('.sp-swiper-fade-top', {
        spaceBetween: 10,
        effect: 'fade',
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
            delay: 2000,
        },
        speed: 2000,
    })
    new Swiper('.sp-swiper-fade2', {
        slidesPerView: 2,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true, //循环滚动
        freeMode: true,
        speed: 6500, //匀速时间
        autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: false,
        },
    })
    new Swiper('.sp-swiper1', {
        spaceBetween: 40,
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
            // delay: 0,
        },
        loop: true,
        on: {
            slideChange: function () {
                if (sp_thum) {
                    sp_thum.slideTo(this.realIndex, 1000, false)
                }
            },
        },
    })
    // 联动
    var sp_thum = new Swiper('.sp-thum', {})
    // 联动
    var sp_thum_m = new Swiper('.sp-thum-m', {})
    // 主图
    var sp_swiper_thum = new Swiper('.sp-swiper1-m', {
        autoplay: {
            disableOnInteraction: false,
            // delay: 0,
        },
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        on: {
            slideChange: function () {
                if (sp_thum_m) {
                    sp_thum_m.slideTo(this.realIndex, 1000, false)
                }
            },
        },
    })
    new Swiper('.sp-swiper2', {
        slideShadows: true,
        slidesPerView: 5,
        spaceBetween: 16,
        centeredSlides: true,
        loop: true, //循环滚动
        freeMode: true,
        speed: 6500, //匀速时间
        autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: false,
        },
    })
    new Swiper('.sp-swiper2-m', {
        slideShadows: true,
        slidesPerView: 1.4,
        spaceBetween: 35,
        centeredSlides: true,
        loop: true, //循环滚动
        freeMode: true,
        speed: 6500, //匀速时间
        autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: false,
        },
    })
    new Swiper('.sp-swiper3', {
        slideShadows: true,
        slidesPerView: 'auto',
        spaceBetween: 40,
        centeredSlides: true,
        loop: true, //循环滚动
        freeMode: true,
        speed: 6500, //匀速时间
        autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: false,
        },
    })
    new Swiper('.sp-swiper4', {
        slideShadows: true,
        slidesPerView: 2.6,
        spaceBetween: 16,
        centeredSlides: true,
        loop: true, //循环滚动
        freeMode: true,
        speed: 4500, //匀速时间
        autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: false,
        },
    })
    new Swiper('.sp-swiper4-m', {
        slideShadows: true,
        slidesPerView: 1.4,
        spaceBetween: 42,
        centeredSlides: true,
        loop: true, //循环滚动
        autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
        },
    })
    new Swiper('.sp-swiper5', {
        slideShadows: true,
        slidesPerView: 3,
        spaceBetween: 36,
        // centeredSlides: true,
        loop: true, //循环滚动
        loopedSlides: 4,
        autoplay: {
            delay: 2000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
        },
    })
    function mainRender() {
        $(function () {
            $('#root').css('zoom', 'normal')
            if (document.body.clientWidth <= 1080) {
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
            } else {
                const scale = document.body.clientWidth / 1920
                $('#root').css('zoom', scale)
            }

            window.addEventListener(
                'resize',
                (function () {
                    var timer
                    return function () {
                        if (timer) clearTimeout(timer)
                        timer = setTimeout(function () {
                            $('#root').css('zoom', 'normal')
                            if (document.body.clientWidth <= 1080) {
                                let scale = document.body.clientWidth / 1080
                                $('#root').css('zoom', scale)
                            } else {
                                const scale = document.body.clientWidth / 1920
                                $('#root').css('zoom', scale)
                            }
                        }, 100)
                    }
                })()
            )
        })

        function lazyLoadImages() {
            // 懒加载
            const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
            const config = {
                rootMargin: '0px 0px 1300px 0px',
                threshold: 0,
            }

            const lazyLoadObserver = new IntersectionObserver(function (
                entries,
                observer
            ) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        // 当图片进入视口时
                        const image = entry.target
                        const dataSrc = image.getAttribute('data-src')
                        image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
                        lazyLoadObserver.unobserve(image) // 停止观察该图片
                    }
                })
            },
                config)

            images.forEach(function (image) {
                lazyLoadObserver.observe(image) // 开始观察每个图片
            })
        }

        function preloadImages(imageArray) {
            // 预加载
            // 检查数组数据结构
            if (Array.isArray(imageArray[0])) {
                // 处理二维数组
                imageArray.forEach((subArray) => {
                    subArray.forEach((url) => {
                        const img = new Image()
                        img.src = url
                    })
                })
            } else {
                // 处理一维数组
                imageArray.forEach((url) => {
                    const img = new Image()
                    img.src = url
                })
            }
        }

        lazyLoadImages()

        preloadImages(spImgList)

        var links = document.querySelectorAll('a[href^="#shopping"]')
        links.forEach(function (link) {
            link.addEventListener('click', function (event) {
                event.preventDefault() // 阻止默认的跳转行为

                // 方式一
                const targetElement = document.getElementById('shopping') // 获取跳转目标节点
                const offsetTop =
                    document.body.clientWidth <= 1080
                        ? targetElement.offsetTop - $('.sp-nav').height()
                        : targetElement.offsetTop
                let sptop = document.body.clientWidth <= 1080 ? 0 : 70

                window.scroll({
                    top:
                        offsetTop * $('div#root').css('zoom') -
                        sptop * $('div#root').css('zoom'),
                    behavior: 'instant', // 直接跳转，无动画
                })
            })
        })

        // IOS字体多了间距的处理 给节点添加 sp_system 类名
        // 判断当前用户是安卓端还是iOS端
        var userAgent = navigator.userAgent || navigator.vendor || window.opera
        var isAndroid = /android/i.test(userAgent)
        var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
        var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

        if (isAndroid) {
            console.log('Android')
        } else if (isIOS) {
            console.log('iOS')
        } else if (isPC) {
            console.log('PC')
        } else {
            $('.sp_system').css('letter-spacing', '-4px')
        }
    }

    mainRender()

    let sp_price1 = 29.9
    let sp_price2 = 39.39
    function calcTotal(price, num) {
        let result = Number(price) * Number(num)
        return result.toFixed(2)
    }
    $('.sp-reduce').click(function () {
        let input = $(this).siblings('input')[0]
        let num = Number(input.value) - 1
        if (num > 0) {
            input.value = num
        }
        changePrice();

    })
    $('.sp-add').click(function () {
        let input = $(this).siblings('input')[0]
        let num = Number(input.value) + 1
        input.value = num
        changePrice();

    })

    // 标题文本渐出
    const graduallyList = document.getElementsByClassName('gradually')
    for (let gradually of graduallyList) {
        const spans = gradually.querySelectorAll('span')
        const paragraph = gradually.querySelector('.sp-sub-title')

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // 给每个 span 和 i 动画
                        spans.forEach((span, index) => {
                            span.style.animation = `swift-up-fade 0.5s ease forwards`
                            span.style.animationDelay = `${index * 0.1}s`

                            const i = span.querySelector('i')
                            if (i) {
                                i.style.animation = `swift-up-fade 0.5s ease forwards`
                                i.style.animationDelay = `${index * 0.1}s`
                            }
                        })

                        // 段落
                        const totalDelay = spans.length * 0.1 + 0.3
                        if (paragraph) {
                            paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
                            paragraph.style.animationDelay = `${totalDelay}s`
                        }

                        observer.unobserve(gradually)
                    }
                })
            },
            {
                threshold: 0.3,
            }
        )
        observer.observe(gradually)
    }

    // // 点击按钮
    // $(".sp-video-btn").click(function () {
    //   $(".sp-mask").css("display", "flex");
    // });

    // 菜单
    $('.sp-menu-btn').click(function (e) {
        $('.sp-menu-mask').show()
    })

    $('.sp-menu-mask').click(function (e) {
        // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
        // } else {
        $('.sp-menu-mask').hide()
        // }
    })

    // 滚动隐藏顶部
    if (
        $(window).scrollTop() >
        $('.sp_header').height() * $('div#root').css('zoom')
    ) {
        $('.sp_header-wrap').addClass('sp-fixed')
    } else {
        $('.sp_header-wrap').removeClass('sp-fixed')
    }

    // // 滚动添加底部
    // if (
    //   $(window).scrollTop() >
    //   $(".sp-part1").height() * $("div#root").css("zoom") -
    //     $(".sp-part1 .swiper").height() * $("div#root").css("zoom")
    // ) {
    //   $(".sp-btn-style2").addClass("sp-fixed-bottom");
    // } else {
    //   $(".sp-btn-style2").removeClass("sp-fixed-bottom");
    // }
    let spTimer = null
    let spHasShown = false // 防止重复显示
    document.querySelector('.sp-btn-style2').style.display = 'none'
    $(window).scroll(function () {
        if (
            $(window).scrollTop() >
            $('.sp_header').height() * $('div#root').css('zoom')
        ) {
            $('.sp_header-wrap').addClass('sp-fixed')
        } else {
            $('.sp_header-wrap').removeClass('sp-fixed')
        }

        // 滚动添加底部
        // if (spHasShown) return // 已经显示就不再触发

        // 如果没有定时器，则开始计时
        if ($(window).scrollTop() > 500) {
            spTimer = setTimeout(function () {
                document.querySelector('.sp-btn-style2').style.display = 'flex'
                spHasShown = true // 标记为已显示
            }, 100)
        } else {
            spTimer = setTimeout(function () {
                document.querySelector('.sp-btn-style2').style.display = 'none'
                spHasShown = false // 标记为已显示
            }, 100)
        }
    })

    $(document).on('click', '.sp_buy_now', function () {
        console.log('xxx111')
    })

    let initNum = 0
    $(document).on('click', '.sp_add_cart', function () {
        // 购物车加购动效
        $(this).children('img').addClass('on')
        $('.sp-cart .num').show()
        setTimeout(function () {
            $(' .cart-btn').children('img').removeClass('on')
        }, 500)
        $(' .sp-cart').addClass('on')
        setTimeout(function () {
            $('.sp-cart').removeClass('on')
        }, 500)

        // let spNum = $('.sp_product_part #calcNumber')[0].value
        // initNum += Number(spNum)

        // $("#calcNumber").val(1);

        // $('.cardNum').each(function () {
        //   $(this).html(initNum)
        // })
        // $('.cardNum').removeClass('sp-gray')
        // handleAddToCart(initNum);

        var data = {
            id: getCur().id,
            quantity: $('#calcNumber').val(),
        };
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            success: function () {
                $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
                    // $("#cardNum").html(result.item_count);
                    $(".cardNum").each(function () {
                        $(this).html(result.item_count);
                        $(this).removeClass("sp-gray");

                    });
                });
            },
            dataType: "json",
        });

        var imgs = $('.sp_product_part .sp-img-inner .sp-img-p.active')
        // var imgs = $(".sp_product_part .sp-img-p.active");

        imgs.each(function () {
            var $img = $(this)
            var flyer = $img[0].cloneNode(true)
            flyer.classList.add('sp_clone')
            $('.sp_product_part').append(flyer)
            $(flyer).css({
                width: $img[0].width,
                height: $img[0].height,
                background: '#e7e9ef',
                position: 'fixed',

                top: $img[0].offsetTop,
                left: $img.offset().left,
                'z-index': 99,
            })
            let finish
            if (document.body.clientWidth <= 1080) {
                finish = $('.sp-btn-style2 .sp-cart')

                $(flyer).animate(
                    {
                        top: $('.sp-btn-style2')[0].offsetTop,
                        left:
                            $('.sp-btn-style2 .sp-cart')[0].offsetLeft + finish.width() / 2,
                        width: 50,
                        height: 50,
                        opacity: 0.4,
                    },
                    500,
                    'linear',
                    function () {
                        $(this).animate(
                            {
                                width: 0,
                                height: 0,
                                opacity: 0,
                            },
                            0,
                            function () {
                                $(this).detach()
                            }
                        )
                    }
                )
            } else {
                finish = $('.sp_pc .sp-top-btn')
                $(flyer).animate(
                    {
                        top: finish[0].offsetTop,
                        left: finish[0].offsetLeft + finish.width() / 2,
                        width: 50,
                        height: 50,
                        opacity: 0.4,
                    },
                    500,
                    'linear',
                    function () {
                        $(this).animate(
                            {
                                width: 0,
                                height: 0,
                                opacity: 0,
                            },
                            0,
                            function () {
                                $(this).detach()
                            }
                        )
                    }
                )
            }
        })
    })
    // 问答
    $('.sp-qa2-question').on('click', function () {
        var $currentItem = $(this).closest('.sp-qa2-item')
        var $answer = $currentItem.find('.sp-qa2-answer')

        // 如果当前项已经打开 -> 关闭它
        if ($currentItem.hasClass('active')) {
            $answer.slideUp(300)
            $currentItem.removeClass('active')
        }
        // 如果当前项是关闭的 -> 开启它 (并关闭其他项)
        else {
            // 关闭其他所有项
            $('.sp-qa2-item').removeClass('active')
            $('.sp-qa2-answer').slideUp(300)

            // 开启当前项
            $currentItem.addClass('active')
            $answer.slideDown(300)
        }
    })

    // 文本渐出动画
    const graduallyList2 = document.getElementsByClassName('sp-fade-box')
    for (let gradually2 of graduallyList2) {
        const paragraph2 = gradually2.querySelectorAll('.sp-ani')

        const observerAni = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        paragraph2.forEach((span, index) => {
                            span.style.animation = `sp-fade-in 1s ease forwards`
                            span.style.animationDelay = `${index * 0.5 + 0.5}s`
                        })

                        observerAni.unobserve(gradually2)
                    }
                })
            },
            {
                threshold: 0.3,
            }
        )
        observerAni.observe(gradually2)
    }
    // 文本渐出动画
    const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
    for (let gradually3 of graduallyList3) {
        const paragraph3 = gradually3.querySelectorAll('.sp-ani2')

        const observerAni = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        paragraph3.forEach((span, index) => {
                            span.style.animation = `sp-fade-left 1s ease forwards`
                            span.style.animationDelay = `${index * 0.3 + 1}s`
                        })

                        observerAni.unobserve(gradually3)
                    }
                })
            },
            {
                threshold: 0.3,
            }
        )
        observerAni.observe(gradually3)
    }
    // .sp-number：进入视口后从 0 增至目标值（仅播放一次）
    // .sp-number-down：进入视口后从 100 减至目标值（仅播放一次）
    ; (function initSpNumberOnView() {
        var DURATION = 4000
        var observerOpts = { root: null, rootMargin: '0px', threshold: 0.25 }

        function parseNumberBlock(el) {
            /* part6：div.sp-number > span；part3：span.sp-number 自身带数字 */
            var span = el.querySelector('span')
            if (!span) span = el
            var raw = span.textContent.replace(/,/g, '').trim()
            var target = parseFloat(raw)
            if (!isFinite(target)) return null
            var decMatch = /^-?\d+\.(\d+)/.exec(raw)
            var decPlaces = decMatch ? decMatch[1].length : 0
            function fmt(n) {
                if (decPlaces > 0) return n.toFixed(decPlaces)
                return String(Math.round(n))
            }
            return {
                span: span,
                target: target,
                fmt: fmt,
                finalStr: fmt(target),
            }
        }

        function animateUp(item) {
            var startTime = null
            function frame(now) {
                if (startTime === null) startTime = now
                var p = Math.min(1, (now - startTime) / DURATION)
                item.span.textContent = item.fmt(item.target * p)
                if (p < 1) requestAnimationFrame(frame)
                else item.span.textContent = item.finalStr
            }
            requestAnimationFrame(frame)
        }

        function animateDownFrom100(item) {
            var from = 327
            var startTime = null
            function frame(now) {
                if (startTime === null) startTime = now
                var p = Math.min(1, (now - startTime) / DURATION)
                var val = from + (item.target - from) * p
                item.span.textContent = item.fmt(val)
                if (p < 1) requestAnimationFrame(frame)
                else item.span.textContent = item.finalStr
            }
            requestAnimationFrame(frame)
        }

        function bind(selector, isDown) {
            document.querySelectorAll(selector).forEach(function (el) {
                var item = parseNumberBlock(el)
                if (!item) return
                item.span.textContent = item.fmt(isDown ? 100 : 0)
                var played = false
                var obs = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (!entry.isIntersecting || played) return
                        played = true
                        obs.unobserve(el)
                        if (isDown) animateDownFrom100(item)
                        else animateUp(item)
                    })
                }, observerOpts)
                obs.observe(el)
            })
        }

        bind('.sp-number', false)
        bind('.sp-number-down', true)
    })()
})
